module.exports = __webpack_public_path__ + "static/media/SearchIcon.e740368d.svg";